import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { getLayerName } from "../../TimeLine/MainTimeLineVisible";
import { LocationMarkerPopup } from "../../mainLayer/MainWindow";
import { useTheme } from "../../theme/ThemeContext";
import { useMenu} from "../../roundMenuContext/roundMenuContext";
import { useEWSContext } from "../../provider/EWSProvider";
import { Coordinate } from "ol/coordinate";



interface ReportIncidentsProps {
  senddValueFromEarlyWarningMenu: (value: string) => void;
  openIncidentDropDown: (open: boolean) => void;
  openTitle: string;
  clickedEWS: boolean;
  showPopupDropDown: boolean;
}

interface EwsSidebar {
  sensorId: string | null,
  coordinates: Coordinate | null,
  adm4_en: string | null,
  active_pcode: string | null,
  end_time: string | null,
  s_desc: string | null,
  severity_index: string | null,
  severity: string | null,
  adm4_pcode: string | null,
  adm3_pcode: string | null,
  adm3_en: string | null,
  adm2_pcode: string | null,
  adm2_en: string | null,
  active_alevel: string | null,
  en_desc: string | null,
  validityPeriod: string | null,
  issued_time: string | null,
  w_status: string | null,
  w_desc: string | null,
  w_name: string | null,
  w_type: string | null,
  adm1_en: string | null
}

const EarlyWarning: React.FC<ReportIncidentsProps> = ({
  senddValueFromEarlyWarningMenu,
  openIncidentDropDown,
  openTitle,
  clickedEWS,
  showPopupDropDown,
}) => {
  const [isClicked, setIsClicked] = useState<boolean>(true);
  const [hoveredEarlyWarning, setHoveredEarlyWarning] = useState(false);
  const { theme } = useTheme();
  const { menu } = useMenu();
  const { clearEWSOpenSidebarMap,clickedString  } = useEWSContext();

  useEffect(() => {
    if (menu==="Early Warning") {
      toggleDropDown();
    } 
  }, [menu]);

  useEffect(() => {
    if (clickedString==="clickEws") {
      toggleDropDown();
    } 
  }, [clickedString]);

  const toggleDropDown = () => {
    openIncidentDropDown(true);
    senddValueFromEarlyWarningMenu("Early Warnings");

    if (!clickedEWS) {
      setIsClicked((prevState) => !prevState);
    }
    getLayerName("ews", true);
  };

  useEffect(() => {
    if (openTitle !== "main") {
      if (openTitle === "Early Warnings") {
        setIsClicked(false);
      } else {
        if (clickedEWS) {
          setIsClicked(false);
        } else {
          setIsClicked(true);
        }
      }
    }
  }, [openTitle]);

  useEffect(() => {
    if (!isClicked) {
      getLayerName("ews", true);
      LocationMarkerPopup("earlywarning");
    } else {
      clearEWSOpenSidebarMap();
      LocationMarkerPopup("earlywarning not");
    }
  }, [isClicked]);

  useEffect(() => {
    if (clickedEWS) {
      setIsClicked(false);
    } else {
      setIsClicked(true);
    }
  }, [clickedEWS]);

  useEffect(() => {
    if (showPopupDropDown === false && clickedEWS === false) {
      setIsClicked(true);
    }
  }, [showPopupDropDown]);

  return (
    <>
      <div className="leftsidemenulist-btn-cover" onClick={toggleDropDown}      onTouchStart={toggleDropDown}>
        <div
          onMouseEnter={() => setHoveredEarlyWarning(true)}
          onMouseLeave={() => setHoveredEarlyWarning(false)}
          className="leftsidemenulist-btns"
        >
          <FontAwesomeIcon
            size="1x"
            icon={faCircleExclamation}
            className="leftside-icon"
          />
        </div>
        {theme === "light" && (
        <div
          className={
            isClicked
              ? hoveredEarlyWarning
                ? "leftsidemenulist-btn-tooltip-hover-light"
                : "leftsidemenulist-btn-tooltip-light"
              : "leftsidemenulist-btn-tooltip-clicked-light"
          }
          onMouseEnter={() => setHoveredEarlyWarning(true)}
          onMouseLeave={() => setHoveredEarlyWarning(false)}
        >
          Early Warning
        </div>
        )}
          {theme !== "light" && (
        <div
          className={
            isClicked
              ? hoveredEarlyWarning
                ? "leftsidemenulist-btn-tooltip-hover"
                : "leftsidemenulist-btn-tooltip"
              : "leftsidemenulist-btn-tooltip-clicked"
          }
          onMouseEnter={() => setHoveredEarlyWarning(true)}
          onMouseLeave={() => setHoveredEarlyWarning(false)}
        >
          Early Warning
        </div>
          )}
      </div>
    </>
  );
};

export default EarlyWarning;
